import { AppConfig } from '../types/config';

import appConfigJson from '../config/app.development.json';

export function getAppConfig(): AppConfig {
  return appConfigJson as AppConfig;
}
